@if (!isError && !isLoading) {
  <ng-container *transloco="let convert;">
    <div
      class="modal--action-list"
      role="dialog"
      id="makeReserveModal"
      aria-modal="true"
      aria-labelledby="make-reserve-modal-title"
      [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.makeReserveModal.ariaLabelMakeReserveModal')"
      [attr.data-track-region]="textHeader"
      >
      <header class="modal__header">
        <h1 class="modal__title fw-normal" id="make-reserve-modal-title" tabindex="-1">
          {{ textHeader }}
        </h1>
      </header>
      <div class="modal__content d-flex flex-column">
        <div class="modal__body dropdown"
          [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.makeReserveModal.ariaLabelSelectedMessage')">
          <label class="sub-header">{{textSubHeader}}</label>
          <div class="vehicle-info__row">
            <label class="fw-bold select-label">{{textDealership}}</label>
            <trap-focus [enableFocusTrap]="dropDownFocusTrap" [enableArrowKeys]="true">
              <app-search-box-input
                [isDealerSeller]="isDealerSeller"
                (dealerSelected)="onDealerSelected($event)"
              ></app-search-box-input>
            </trap-focus>
            @if (isSelectTextErrorValue | async) {
              <p class="text-danger mb-0 fw-bold">{{selectTextError}}</p>
            }
          </div>
        </div>
        <div class="modal__actions">
          <button
            class="btn btn-primary me-md-2 mb-3 mb-md-0"
            data-track-elem="button"
            data-track-name="Search"
            allytmln="Reserve"
            [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.makeReserveModal.ariaLabelReserve')"
            (click)="makeReserve()"
            [disabled]="isIsvFileProcessing"
          >
            {{convert('sellModule.manageInventory.actionListModal.makeReserveModal.ariaLabelReserve')}}
          </button>
          <button
            class="btn cancel btn-link outline-focus ms-md-2"
            allytmln="Cancel"
            [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.makeReserveModal.ariaLabelCancel')"
            (click)="closeModal()">
            <span>{{convert('sellModule.manageInventory.actionListModal.makeReserveModal.ariaLabelCancel')}}</span>
          </button>
        </div>
      </div>
      <button
        class="modal__close"
        data-dismiss="modal"
        [attr.aria-label]="convert('common.modalClose')"
        (click)="closeModal()"
        data-track-elem="icon"
        data-track-name="Close"
        data-track-trigger="close">
        <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
      </button>
    </div>
  </ng-container>
}
@if (isLoading) {
  <div class="spinner-container">
    <app-spinner></app-spinner>
  </div>
}
@if (isError) {
  <div class="error-container">
    <button
      id="error-close"
      class="error__close"
      aria-label="Close modal"
      (click)="closeModal()"
      (keydown.escape)="closeModal()"
      data-track-elem="icon"
      data-track-name="close"
      data-track-trigger="close"
      >
      <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
    </button>
    <div class="content text-center">
      <span class="text-danger" aria-hidden="true"><app-error-icon fill="currentColor"></app-error-icon></span>
      <p>{{textError}}</p>
    </div>
  </div>
}
